import React from "react";
import { Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-neutral-900 border-t border-neutral-200 pt-16 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col gap-10 lg:grid lg:grid-cols-12">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="diamond-divider" />
              <span className="font-display text-neutral-900 text-xl font-semibold">
                Deluxe / Diamond Detailing
              </span>
            </div>
            <p className="text-neutral-500 mt-4 max-w-md leading-relaxed">
              Premium mobile car detailing. Showroom-quality results delivered
              to your home or workplace.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="tel:0450539879"
                data-testid="footer-call-1"
                className="btn-ghost text-sm"
              >
                <Phone size={14} /> 0450 539 879
              </a>
              <a
                href="tel:0478955883"
                data-testid="footer-call-2"
                className="btn-ghost text-sm"
              >
                <Phone size={14} /> 0478 955 883
              </a>
            </div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="overline mb-4">Explore</div>
            <ul className="space-y-2 text-sm text-neutral-600">
              <li><a className="hover:text-neutral-900" href="#about">About</a></li>
              <li><a className="hover:text-neutral-900" href="#services">Services</a></li>
              <li><a className="hover:text-neutral-900" href="#gallery">Gallery</a></li>
              <li><a className="hover:text-neutral-900" href="#reviews">Reviews</a></li>
              <li><a className="hover:text-neutral-900" href="#faqs">FAQs</a></li>
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <div className="overline mb-4">Get In Touch</div>
            <a
              href="mailto:deluxe.diamond.detailing0@gmail.com"
              className="flex items-center gap-2 text-neutral-600 hover:text-neutral-900 text-sm break-all"
            >
              <Mail size={14} /> deluxe.diamond.detailing0@gmail.com
            </a>
            <a
              href="#book"
              data-testid="footer-book-cta"
              className="mt-5 btn-primary text-sm inline-flex"
            >
              Book Your Detail
            </a>
          </div>
        </div>

        <div className="hairline my-10" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-neutral-400">
          <div>
            © {new Date().getFullYear()} Deluxe Diamond Detailing — Precision.
            Protection. Perfection.
          </div>
          <div>Mobile Car Detailing · Australia</div>
        </div>
      </div>
    </footer>
  );
}
